import type { ExpressPaymentType } from '@stripe/stripe-js'

const WALLET_PAYMENT_TYPES: ReadonlySet<ExpressPaymentType> = new Set(['apple_pay', 'google_pay', 'link'])

/** The API has no wallet payment source type, so report wallet payments (incl. card-backed Link) as 'card'. */
export function sourceTypeForExpressPayment(expressPaymentType: ExpressPaymentType): string {
  return WALLET_PAYMENT_TYPES.has(expressPaymentType) ? 'card' : expressPaymentType
}
